export default "__VITE_ASSET__yUXBPS7C__"